export default __webpack_public_path__ + "static/media/link-horizontal.b5fea07a.svg";